
let entityCache: Record<string, {id: number; name: string }[]> | null = null;

export const setEntityCache = (
    data: Record<string, { id: number; name: string }[]>
) => {
    entityCache = data;

};

export const getEntityCache = () => {
    return entityCache;
};


